/** Format a stored four-decimal measurement without its trailing zeros; zero and null are blank. */
export function formatMeasurement(value: string | null): string {
    if (value === null || Number(value) === 0) {
        return ""
    }

    return String(parseFloat(value))
}

export function formatDimensions(item: CatalogItemDetails): string {
    const dimensionValues = [item.length, item.width, item.height].map(formatMeasurement)

    if (dimensionValues.every((value) => value === "")) {
        return ""
    }

    const unitSuffix = item.dimension_unit_display ? ` ${item.dimension_unit_display}` : ""
    return `${dimensionValues.map((value) => value || "—").join(" × ")}${unitSuffix} (L × W × H)`
}

export function formatCategoryPath(category: CatalogItemDetails["categories"][number]): string {
    return [...category.ancestor_names, category.name].join(" / ")
}

export function formatModifierAdjustment(
    modifier: CatalogItemModifierGroup["modifiers"][number],
    formatCurrency: (value: number | string) => string,
): string {
    if (!modifier.price_adjustment_type || modifier.price_adjustment_value === null) {
        return ""
    }

    if (modifier.price_adjustment_type === "percentage") {
        return ` (+${modifier.price_adjustment_value}%)`
    }

    return ` (+${formatCurrency(modifier.price_adjustment_value)})`
}
